import { render, staticRenderFns } from "./bottom_navigation.vue?vue&type=template&id=6e9fefe2&"
import script from "./bottom_navigation.vue?vue&type=script&lang=js&"
export * from "./bottom_navigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports